import { sanitizeUrl } from "./url"

export function manage(form: HTMLFormElement) {
  function hideMessage(clazz: "success" | "error") {
    form.classList.remove(clazz)
  }
  function showMessage(
    clazz: "success" | "error",
    message: string | undefined
  ) {
    form.classList.add(clazz)
    const messageField = form.querySelector("." + clazz + ".message p")
    if (messageField && message) {
      messageField.textContent = message
    }
  }
  const submitButton = form.querySelector("[type='submit']")
  if (!submitButton) {
    throw new Error("submit button missing")
  }
  form.onsubmit = function () {
    hideMessage("success")
    hideMessage("error")
    const formData = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action, true)
    xhr.onload = function () {
      const responseContentType = xhr
        .getResponseHeader("Content-Type")
        ?.split(";")[0]

      const isErrorResponse = xhr.status >= 400
      let message: string | undefined = undefined

      switch (responseContentType) {
        case "application/json":
          message = JSON.parse(xhr.response)["message"]
          break
      }

      submitButton.classList.remove("loading")

      if (isErrorResponse) {
        showMessage("error", message)
        return
      }

      const targetUrl = form.getAttribute("target-url")
      if (targetUrl) {
        document.location.assign(sanitizeUrl(targetUrl))
      }

      showMessage("success", message)
    }
    xhr.send(formData)
    submitButton.classList.add("loading")
    return false
  }
}

export function manageAll() {
  const forms = document.querySelectorAll("form.managed")
  for (let i = 0; i < forms.length; ++i) {
    const form = forms[i] as HTMLFormElement
    manage(form)
  }
}
